export const applyFilter = filter => ({
    type: 'APPLY_FILTER',
    payload: filter
})


// WEBPACK FOOTER //
// ./src/actions/settingsActions.js